export default "__VITE_ASSET__DARq_DFC__"